module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hrms75e-detail",
    attrs: {
      "id": "hrms75e-detail"
    }
  }, [_c('div', {
    staticClass: "hrms75e-box clearfix"
  }, [_c('div', {
    staticClass: "col-md-5 panel-left"
  }, [_c('detail-cours', {
    attrs: {
      "labels": _vm.labels,
      "detail": _vm.detail.cours,
      "eventBtn": _vm.eventBtn,
      "searchIndex": _vm.searchIndex,
      "searchDetailCours": _vm.searchDetailCours,
      "receivedHrms75eDetail": _vm.receivedHrms75eDetail,
      "labelsButton": _vm.labelsButton,
      "indexSelected": _vm.indexSelected,
      "lovCurrentDesc": _vm.lovCurrentDesc,
      "detailCoursColumns": _vm.detailCoursColumns,
      "postHrms75eDetailCoursSave": _vm.postHrms75eDetailCoursSave,
      "nowLang": _vm.nowLang
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "box-footer"
  }, [_c('button', {
    staticClass: "btn bg-dark-gray",
    attrs: {
      "type": "button",
      "value": "Back"
    },
    on: {
      "click": function($event) {
        _vm.toggle('index')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-circle-left"
  }), _vm._v(_vm._s(_vm.labelsButton['back']))])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-7 panel-right"
  }, [_c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group margin-b-15"
  }, [_c('label', {
    staticClass: "col-md-4 control-label"
  }, [_vm._v(_vm._s(_vm.labels['HRMS75EC1']['40']))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-control readonly-field-color"
  }, [_vm._v(_vm._s(_vm.codempid) + " - " + _vm._s(_vm.descCodempid))])])])]), _vm._v(" "), _c('div', {
    staticClass: "box-tab"
  }, [_c('div', {
    attrs: {
      "id": "accordion"
    }
  }, [_c('detail-tab1', {
    attrs: {
      "labels": _vm.labels,
      "labelsButton": _vm.labelsButton,
      "nowLang": _vm.nowLang,
      "detail": _vm.detail.tab1,
      "detailTab1Columns": _vm.detailTab1Columns,
      "setAddCodcours": _vm.setAddCodcours
    }
  }), _vm._v(" "), _c('detail-tab2', {
    attrs: {
      "labels": _vm.labels,
      "labelsButton": _vm.labelsButton,
      "nowLang": _vm.nowLang,
      "detail": _vm.detail.tab2,
      "setAddCodcours": _vm.setAddCodcours,
      "detailTab2Columns": _vm.detailTab2Columns,
      "detailTab2Popup": _vm.detailTab2Popup,
      "detailTab2PopupColumns": _vm.detailTab2PopupColumns,
      "receivedHrms75eDetailTab2Popup": _vm.receivedHrms75eDetailTab2Popup
    }
  }), _vm._v(" "), _c('detail-tab3', {
    attrs: {
      "labels": _vm.labels,
      "nowLang": _vm.nowLang,
      "labelsButton": _vm.labelsButton,
      "detail": _vm.detail.tab3,
      "setAddCodcours": _vm.setAddCodcours,
      "detailTab3MaxRowspan": _vm.detailTab3MaxRowspan,
      "detailTab3Columns": _vm.detailTab3Columns
    }
  }), _vm._v(" "), _c('detail-tab4', {
    attrs: {
      "labels": _vm.labels,
      "labelsButton": _vm.labelsButton,
      "detail": _vm.detail.tab4,
      "codempid": _vm.codempid,
      "setAddCodcours": _vm.setAddCodcours,
      "detailTab4Columns": _vm.detailTab4Columns,
      "detailTab4Popup": _vm.detailTab4Popup,
      "detailTab4PopupColumns": _vm.detailTab4PopupColumns,
      "receivedHrms75eDetailTab4Popup": _vm.receivedHrms75eDetailTab4Popup
    }
  }), _vm._v(" "), _c('detail-tab5', {
    attrs: {
      "labels": _vm.labels,
      "nowLang": _vm.nowLang,
      "labelsButton": _vm.labelsButton,
      "detail": _vm.detail.tab5,
      "detailTab5MaxRowspan": _vm.detailTab5MaxRowspan,
      "detailTab5Columns": _vm.detailTab5Columns
    }
  })], 1)])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1cf89280!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/hrms75e/detail.vue
// module id = 3609
// module chunks = 1